import React from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
import { HideMobile, ShowMobile } from "../components/blocks/Responsive";
import Background from "./blocks/Background";
import Section from "./blocks/Section";
import Spacer from "./blocks/Spacer";
import AspectImage from "./atoms/AspectImage";
import { P, Description } from "./typography";
import { r, getThemeColor } from "../utils";

const Container = Background.extend`
  display: flex;
  height: 20rem;
  ${props => props.theme.media.mobile`
    flex-wrap: wrap;
    height: auto;
  `};
`;

const Body = styled.div`
  color: ${props => props.theme.colors.white};
  background-color: ${getThemeColor("teal")};
  padding: 3rem;
  ${props => props.theme.media.tablet`
    padding: 2rem;
  `};
`;

const BodyText = P.extend`
  font-size: 1.35rem;
  ${props => props.theme.media.card`
    font-size: 1.1rem;
  `};
  a,
  a:visited {
    color: white;
  }
`;

export default ({
  picture = "",
  title = "",
  subtitle = "",
  text = "",
  color = "teal",
  pictureAlign = "left"
}) =>
  <Section color="halfGrey" fixed={true}>
    <Container color="halfGrey" style={{ display: "flex" }}>
      {pictureAlign === "left" &&
        <HideMobile style={{ flex: 1 }}>
          <AspectImage direction="vertical" aspect={1} src={picture} inline />
        </HideMobile>}
      <ShowMobile>
        <AspectImage direction="horizontal" aspect={1} src={picture} inline />
      </ShowMobile>
      <Body color={color} style={{ flex: 2 }}>
        <P serif color="white">
          {title}
        </P>
        <Description color="white">
          {subtitle}
        </Description>
        <Spacer span={0.5} />
        <BodyText color="white">
          <ReactMarkdown source={text} />
        </BodyText>
      </Body>
      {pictureAlign === "right" &&
        <HideMobile style={{ flex: 1 }}>
          <AspectImage direction="vertical" aspect={1} src={picture} inline />
        </HideMobile>}
    </Container>
  </Section>;



// WEBPACK FOOTER //
// ./src/components/PictureCard.js